export default __webpack_public_path__ + "static/media/trampapo_01-07.8ed4c430.jpg";